export default "__VITE_ASSET__B3S6Df_1__"